import { useEffect, useState } from "react";
import { Alert, Spinner } from "reactstrap";
import { TextTitleStyle, TitleStyle } from "../styles/TitleStyle";

export default function NotAllow() {
  
  const [loading, setLoading] = useState(true);
 

  useEffect(() => {  setTimeout(() => {
    setLoading(false);
  }, 2000);},[])

  
  return (
    <div style={{ 
    display: "flex",
    flexDirection: "column",
    justifyContent: 'center',
    alignItems: 'center'}}>
    {!loading ? (<>
    <Alert color="danger"><h1 style={{...TitleStyle}}>Route not allow</h1></Alert>
    <Alert color="warning"><h1 style={{...TextTitleStyle}}>Please come back with a valid user profile</h1></Alert></>
    ) : (
    <Spinner 
    color="primary"
    style={{height: '5rem',width: '5rem'}}
    >Loading...</Spinner>
    )}
  </div>
  )
}
